import * as react from "react";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { value } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { equals, int32ToString } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { DOMAttr, DangerousHtml, HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { nothing, errorMsg, spinner, linkicon } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { CollapsableElement } from "../../../../Bfs.Web.Portale/Collapsable.fs.js";
import { Option, ISize, column } from "../../../fable_modules/Fulma.3.0.0/Layouts/Column.fs.js";
import { Screen } from "../../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { concat, singleton as singleton_1, append, map, toArray, empty, ofArray } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { singleton, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { Msg_$reflection, Model_$reflection, Msg } from "./Types.fs.js";
import { isNullOrWhiteSpace, printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { Record } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, lambda_type, unit_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Option as Option_1, columns } from "../../../fable_modules/Fulma.3.0.0/Layouts/Columns.fs.js";
import { Option as Option_2, div } from "../../../fable_modules/Fulma.3.0.0/Elements/Form/Field.fs.js";
import { Option as Option_3, div as div_1 } from "../../../fable_modules/Fulma.3.0.0/Elements/Form/Control.fs.js";
import { DropdownProps$1, bfsDropdown } from "../Shared/Dropdown.fs.js";

export const viewNone = (() => {
    let children_2;
    const children_4 = [(children_2 = [react.createElement("p", {
        className: "card-header-title",
    }, "Keine Fragen oder Antworten gefunden.")], react.createElement("header", {
        className: "card-header",
    }, ...children_2))];
    return react.createElement("div", {
        className: "card",
    }, ...children_4);
})();

export const viewFaqEntry = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Faq\\View.fs") + "#L") + int32ToString(value(30))) + ";") + "Bfs.Web.Data.Service.Contracts.Kundenportal.Faq.Faq", value("viewFaqEntry"), (currentFaq) => {
    let props, children_8, children_6;
    const isExpanded = react.useState(false);
    const iconclass = (isExpanded[0]) ? " upsidedown" : "";
    let content;
    const children_2 = [(props = [new HTMLAttr(65, ["content"]), new DOMAttr(0, [new DangerousHtml(currentFaq.AntwortHtml)])], react.createElement("div", keyValueList(props, 1)))];
    content = react.createElement("div", {
        className: "card-content faq-card-content",
    }, ...children_2);
    const children_10 = [(children_8 = [react.createElement("p", {
        className: "card-header-title",
    }, currentFaq.Frage), (children_6 = [linkicon("fas fa-chevron-down" + iconclass)], react.createElement("a", {
        className: "card-header-icon",
    }, ...children_6))], react.createElement("header", {
        className: "card-header",
        onClick: (_arg) => {
            isExpanded[1](!(isExpanded[0]));
        },
    }, ...children_8)), CollapsableElement([content, isExpanded[0]])];
    return react.createElement("div", {
        className: "card",
    }, ...children_10);
}, undefined, undefined, "Of");

export function faqList(model, dispatch) {
    return column(ofArray([new Option(0, [new Screen(1, []), new ISize(12, [])]), new Option(0, [new Screen(5, []), new ISize(16, [])])]), toList(delay(() => {
        let children_2;
        const matchValue = model.Faqs;
        return (matchValue.tag === 1) ? singleton(spinner) : ((matchValue.tag === 2) ? singleton(errorMsg("Fehler beim Laden der FAQs!")) : ((matchValue.tag === 3) ? (equals(matchValue.fields[0], empty()) ? singleton(viewNone) : singleton((children_2 = [toArray(map(viewFaqEntry, matchValue.fields[0]))], react.createElement("ul", {}, ...children_2)))) : singleton(react.createElement("div", {}))));
    })));
}

export function kategorie(name, currentFilter, dispatch) {
    let children_2;
    const props_4 = [new HTMLAttr(65, ["wishlist-item " + ((name === currentFilter) ? " is-active" : "")]), new DOMAttr(40, [(_arg) => {
        dispatch(new Msg(2, [name]));
    }])];
    const children_4 = [(children_2 = toList(delay(() => singleton(react.createElement("a", {}, name)))), react.createElement("div", {
        className: "item-wrapper",
    }, ...children_2))];
    return react.createElement("li", keyValueList(props_4, 1), ...children_4);
}

export function searchResultkategorie(query) {
    let children_2;
    const children_4 = [(children_2 = toList(delay(() => {
        let children;
        return singleton((children = [toText(printf("Suchergebnis \'%s\'"))(query)], react.createElement("a", {}, ...children)));
    })), react.createElement("div", {
        className: "item-wrapper",
    }, ...children_2))];
    return react.createElement("li", {
        className: "wishlist-item is-active",
    }, ...children_4);
}

export function onSearchEnter(dispatch) {
    const q = document.getElementById("faq-search").value;
    if (!isNullOrWhiteSpace(q)) {
        dispatch(new Msg(4, [q]));
    }
}

export function searchBox(dispatch) {
    let children, children_4;
    const children_6 = [(children = [react.createElement("input", {
        id: "faq-search",
        className: "input",
        type: "text",
        defaultValue: "",
        onKeyDown: (e) => {
            if (e.key === "Enter") {
                onSearchEnter(dispatch);
            }
        },
        placeholder: "Suche",
    })], react.createElement("div", {
        className: "control",
    }, ...children)), (children_4 = [react.createElement("a", {
        className: "bfsbutton ",
        onClick: (_arg) => {
            onSearchEnter(dispatch);
        },
    }, "suchen")], react.createElement("div", {
        className: "control",
    }, ...children_4))];
    return react.createElement("div", {
        className: "field has-addons ",
    }, ...children_6);
}

export function headertext(model) {
    const matchValue = model.SelectedKategorie;
    switch (matchValue.tag) {
        case 1:
            return toText(printf("Häufige Fragen und Antworten - %s"))(matchValue.fields[0]);
        case 2:
            return toText(printf("Häufige Fragen und Antworten - \'%s\'"))(matchValue.fields[0]);
        default:
            return "Häufige Fragen und Antworten";
    }
}

export class MobileHeaderProps extends Record {
    constructor(Model, Dispatch) {
        super();
        this.Model = Model;
        this.Dispatch = Dispatch;
    }
}

export function MobileHeaderProps_$reflection() {
    return record_type("Faq.View.MobileHeaderProps", [], MobileHeaderProps, () => [["Model", Model_$reflection()], ["Dispatch", lambda_type(Msg_$reflection(), unit_type)]]);
}

export const mobileHeader = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Faq\\View.fs") + "#L") + int32ToString(value(129))) + ";") + "Faq.View.MobileHeaderProps", value("mobileHeader"), (props) => {
    let children, children_6, props_3, children_4;
    const isOpen = react.useState(false);
    const searchText = react.useState("");
    const formatSuchergebnis = (query) => (`Suchergebnis '${query}'`);
    let selectedKategorieText;
    const matchValue = props.Model.SelectedKategorie;
    selectedKategorieText = ((matchValue.tag === 1) ? matchValue.fields[0] : ((matchValue.tag === 2) ? formatSuchergebnis(matchValue.fields[0]) : " - "));
    const performSearch = (_arg) => {
        if ((searchText[0]) !== "") {
            props.Dispatch(new Msg(4, [searchText[0]]));
        }
    };
    const matchValue_1 = props.Model.Kategorien;
    switch (matchValue_1.tag) {
        case 1:
            return spinner;
        case 2:
            return errorMsg("Ladefehler");
        case 3: {
            const categoryList = matchValue_1.fields[0];
            const icon = (isOpen[0]) ? "fa-chevron-up" : "fa-chevron-down";
            let categoryList_1;
            const matchValue_3 = props.Model.SelectedKategorie;
            categoryList_1 = ((matchValue_3.tag === 2) ? append(singleton_1(formatSuchergebnis(matchValue_3.fields[0])), categoryList) : categoryList);
            return columns(singleton_1(new Option_1(8, ["is-hidden-desktop category-header-faq is-flex-direction-column is-align-items-start mobile-header-faq"])), singleton_1(column(singleton_1(new Option(0, [new Screen(0, []), new ISize(18, [])])), ofArray([(children = [headertext(props.Model)], react.createElement("h2", {}, ...children)), (children_6 = [div(singleton_1(new Option_2(0, [])), ofArray([div_1(singleton_1(new Option_3(3, [])), singleton_1((props_3 = [new HTMLAttr(99, ["faq-search"]), new HTMLAttr(65, ["input"]), new HTMLAttr(159, ["text"]), new HTMLAttr(128, ["Suche"]), new HTMLAttr(161, [searchText[0]]), new DOMAttr(9, [(e) => {
                const arg = e.target.value;
                searchText[1](arg);
            }])], react.createElement("input", keyValueList(props_3, 1))))), (children_4 = [react.createElement("a", {
                className: "bfsbutton ",
                onClick: performSearch,
            }, "Suchen")], react.createElement("div", {
                className: "control",
            }, ...children_4))]))], react.createElement("form", {
                onSubmit: performSearch,
                className: "mb-2",
            }, ...children_6)), div(empty(), singleton_1(div_1(singleton_1(new Option_3(3, [])), singleton_1(bfsDropdown()(new DropdownProps$1(categoryList_1, selectedKategorieText, (x_1) => x_1, (x) => x, (category) => {
                props.Dispatch(new Msg(2, [category]));
            }))))))]))));
        }
        default:
            return nothing;
    }
}, undefined, undefined, "Of");

export function kategorienList(kategorien, selectedKategorie, dispatch) {
    let children_2, children;
    const selectedKategorieText = (selectedKategorie.tag === 1) ? selectedKategorie.fields[0] : "-";
    const children_4 = [(children_2 = [(children = toList(delay(() => ((kategorien.tag === 1) ? singleton(spinner) : ((kategorien.tag === 2) ? singleton(errorMsg("Ladefehler")) : ((kategorien.tag === 3) ? singleton(toArray(concat([(selectedKategorie.tag === 2) ? singleton_1(searchResultkategorie(selectedKategorie.fields[0])) : empty(), map((x) => kategorie(x, selectedKategorieText, dispatch), kategorien.fields[0])]))) : singleton(nothing)))))), react.createElement("ul", {
        className: "wishlists",
    }, ...children))], react.createElement("div", {
        className: "flat-card is-auto menu-card",
    }, ...children_2))];
    return react.createElement("div", {
        className: "column is-4 is-hidden-touch",
    }, ...children_4);
}

export function header(model, dispatch) {
    let children;
    const children_2 = [(children = [headertext(model)], react.createElement("h2", {}, ...children)), searchBox(dispatch)];
    return react.createElement("div", {
        className: "category-header-faq is-hidden-touch",
    }, ...children_2);
}

export function view(model, dispatch, navigateTo) {
    let children;
    const children_2 = [header(model, dispatch), mobileHeader(new MobileHeaderProps(model, dispatch)), (children = [kategorienList(model.Kategorien, model.SelectedKategorie, dispatch), faqList(model, dispatch)], react.createElement("div", {
        className: "columns is-product-list is-multiline faq",
    }, ...children))];
    return react.createElement("div", {}, ...children_2);
}

//# sourceMappingURL=View.fs.js.map
